export enum ExchangeCrnCreationUponEnum {
  RETURN_CONFIRMATION = 'return_confirmation',
  OPENED_AUTHORIZATION = 'opened_authorization',
}
